export default "<span style=\"padding: 0 8px\">{{ data }}</span>\n";